<template>
  <div class="_content">
    <div class="inWrap">
      <div class="header">
        <!-- <div class="close" @click="back"></div> -->
      </div>
      <div class="logo">
        <img src="@/imgs/shopLogo.png" width="100%" />
        <div class="logo-desc">欢迎使用商户管理平台</div>
      </div>
      <div class="userInfo">
        <div class="name">
          <div class="nameinput">
            <input v-model="phone" type="number" placeholder="请输入手机号" maxlength="11" :readonly="phoneReadonly" />
            <div class="clear" @click="clear('phone')" v-show="phone.length > 0 && !phoneReadonly"></div>
          </div>
        </div>
        <div class="yanzhengma">
          <div class="yzminput">
            <input type="number" placeholder="请输入验证码" maxlength="4" v-model="code" :readonly="readonly" />
            <div class="clear" @click="clear('code')" v-show="code.length > 0"></div>
          </div>
          <div :class="'getyzm ' + yzmClass" @click="getCode" v-text="codeText"></div>
        </div>
      </div>
      <div :class="'loginBtn ' + codeClass" @click="signIn">
        登录
      </div>
    </div>
    <div class="bottom-content" v-call="'400-176-8848'">没收到验证码？咨询客服<span>400-176-8848</span></div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '300px', height: '150px' }"
      :vSpace="20"
      :phone="phone"
      @success="getCodeSuccess"
    />
  </div>
</template>

<script>
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
import config from '@/configs/config'
import Verify from '../verifition/Verify.vue'
const UUID = tuhu.util.uuid()
export default {
  components: {
    Verify
  },
  data() {
    return {
      options: null,
      locked: false,
      phone: '',
      _loginSuccess: false,
      _blackBox: null,
      readonly: false,
      phoneReadonly: false,
      code: '',
      yzmClass: '',
      codeClass: '',
      codeText: '获取验证码'
    }
  },
  mounted() {
    // let vConsole = new VConsole()
    // tuhu.localStorage.clear()

    // 保存需要保留的值 这里是滑动验证需要的2个值 需要兼容原来逻辑清楚所有，但本次滑动验证需要保留这两个值
    const sliderValue = localStorage.getItem('slider')
    const pointValue = localStorage.getItem('point')

    // 清空所有
    localStorage.clear()

    // 恢复需要保留的值
    if (sliderValue) localStorage.setItem('slider', sliderValue)
    if (pointValue) localStorage.setItem('point', pointValue)
    if (!this.options) return
    const { phone } = this.options
    if (phone) {
      this.phone = phone + ''
      this.phoneReadonly = true
      Vue.nextTick(() => {
        this.getCode()
      })
    }
  },
  beforeDestroy() {
    if (!this._loginSuccess) {
      this.options.resolve({
        islogin: false
      })
    }
  },
  watch: {
    phone(val) {
      if (val.length > 11) {
        this.phone = val.substr(0, 11)
        return
      }

      if (val.length === 11 && /\d{11}/.test(val)) {
        this.yzmClass = 'active'
      } else {
        this.yzmClass = ''
      }
    },
    code(val) {
      if (val.length === 4 && /\d{4}/.test(val)) {
        this.codeClass = 'active'
      } else {
        this.codeClass = ''
      }
    },
    yzmClass(val) {
      if (val === 'djs') {
        let times = 60
        this.codeText = times-- + '秒后重发'
        const interval = setInterval(() => {
          this.codeText = times-- + '秒后重发'

          if (times < 0) {
            this.locked = false
            this.yzmClass = 'active'
            this.codeText = '获取验证码'
            clearInterval(interval)
          }
        }, 1000)
      }
    }
  },
  methods: {
    async getCodeSuccess() {
      this.locked = true
      this.yzmClass = 'djs'
      this.readonly = false
    },
    clear(val) {
      this[val] = ''
    },
    // back() {
    //   return tuhu.navigateBack()
    // },
    signIn() {
      if (!this.phone || this.phone.length !== 11) return tuhu.toast('请填写手机号')
      if (!this.code) return tuhu.toast('请填写验证码')
      const params = {
        phone: this.phone,
        verificationCode: this.code,
        source: 3, // 来源，商户端3
        openId: tuhu.getParam('openId')
      }

      tuhu
        .fetch(`${config.apis.LOGIN}`, {
          method: 'post',
          body: JSON.stringify(params)
        })
        .then(data => {
          console.log(data, data.code === '200')
          if (data && data.code === '200') {
            tuhu.fetch(`${config.apis.GET_USERINFO}`).then(res => {
              // get用户信息
              if (res && res.code === '200') {
                this._loginSuccess = true

                const userInfoPromise = tuhu._setUserInfo(res.data) // 返回数据

                if (this.options && this.options.resolve) {
                  this.options.resolve(userInfoPromise)
                }
                // tuhu.navigateTo({
                //   url: '/pages/home/index'
                // })
                if (location.host.indexOf('localhost') > -1) {
                  setTimeout(() => {
                    location.replace(`${location.origin}/pages/home/index`)
                  }, 200)
                } else {
                  setTimeout(() => {
                    location.replace(`${location.origin}/shop/index.html`)
                  }, 200)
                }

                // location.replace(`${location.origin}/shop/index.html`)

                // // openId为微信环境 后端返回
                // if ((this.options && !this.options.direct && !this.options.redirectUrl) || tuhu.getParam('openId')) {
                //   if (location.host.indexOf('localhost') > -1) {
                //     setTimeout(() => {
                //       location.replace(`${location.origin}/pages/home/index`)
                //     }, 200)
                //   } else {
                //     setTimeout(() => {
                //       location.replace(`${location.origin}/shop/index.html`)
                //     }, 200)
                //   }
                // }
              } else {
                tuhu.toast(data.message || '网络异常')
                console.log('未获取到用户信息')
              }
            })
          } else {
            tuhu.toast(data.message || '网络错误')
          }
        })
        .catch(() => {
          return {
            islogin: false
          }
        })
    },
    async getCode() {
      if (this.locked) {
        return
      }
      if (!this.yzmClass) {
        return
      }
      this.$refs.verify.show()

      /*  this.locked = true
      setTimeout(() => {
        tuhu
          .fetch(`${config.apis.GET_CODE}` + `/${this.phone}/3`)
          .then(data => {
            if (data.code === '200') {
              this.yzmClass = 'djs'
              this.readonly = false
            } else {
              this.locked = false
              tuhu.toast(data.message || '网络异常')
            }
          })
          .catch(() => {
            this.locked = false
          })
      }, 1000) */
    }
  }
}
</script>
<style scoped>
input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
}
input::-moz-placeholder {
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
}
input {
  border: 0;
  line-height: normal;
  outline: none;
  -webkit-appearance: none;
}
.weui-cell {
  position: relative;
}
.weui-cell::before {
  content: ' ';
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0px;
  border-top: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.inWrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.inWrap .header {
  display: flex;
  justify-content: space-between;
  padding: 34px 15px 0;
}
.inWrap .header .close {
  background: url(../../imgs/tutai/close.png) no-repeat;
  width: 16px;
  height: 16px;
  background-size: contain;
}
.inWrap .header .zhuce {
  font-size: 14px;
  color: #666666;
}
.inWrap .logo {
  margin-top: 32px;
  padding: 0 30px;
}
.inWrap .logo .logo-desc {
  color: #000;
  font-size: 20px;
  line-height: 20px;
  margin-top: 40px;
  font-weight: 400;
}
.inWrap .logo .logo-title {
  width: 44px;
  height: 23px;
  margin: 0 auto;
  display: block;
  position: absolute;
  right: -53px;
  top: 3px;
}
.inWrap .userInfo {
  margin-top: 40px;
  padding: 0 30px;
}
.inWrap .userInfo .name {
  display: flex;
  justify-content: space-between;
  height: 48px;
  align-items: center;
  position: relative;
}
.inWrap .userInfo .name .nameinput {
  flex: 1;
  height: 100%;
  position: relative;
}
.inWrap .userInfo .name .nameinput input {
  height: 48px;
  width: 100%;
  border: 0;
  font-size: 14px;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);
}
.inWrap .userInfo .name .nameinput .clear {
  background: url(../../imgs/delete.png) no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 16px;
}
.inWrap .userInfo .yanzhengma .getyzm {
  width: 95px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 4px;
  color: #d9d9d9;
  font-size: 12px;
}
.inWrap .userInfo .yanzhengma .getyzm.djs {
  color: #808080;
}
.inWrap .userInfo .yanzhengma .getyzm.active {
  color: rgba(0, 110, 239, 1);
}
.inWrap .userInfo .yanzhengma {
  height: 48px;
  display: flex;
  position: relative;
}
.inWrap .userInfo .yanzhengma .yzminput {
  flex: 1;
  height: 100%;
  position: relative;
}
.inWrap .userInfo .yanzhengma .yzminput input {
  height: 48px;
  border: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
  width: 150px;
  background-color: rgba(255, 255, 255, 0);
}
.inWrap .userInfo .yanzhengma .yzminput .clear {
  background: url(../../imgs/delete.png) no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 16px;
}
.inWrap .userInfo .yanzhengma::before,
.inWrap .userInfo .name::before {
  content: ' ';
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0px;
  border-top: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.inWrap .loginBtn {
  margin: 0 30px;
  margin-top: 30px;
  /* background-color: #d9d9d9; */
  text-align: center;
  color: #ffffff;
  border-radius: 5px;
  font-size: 16px;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(140deg, rgba(1, 183, 255, 1) 0%, rgba(0, 110, 239, 1) 100%);
}
.inWrap .loginBtn.active {
  background: linear-gradient(140deg, rgba(1, 183, 255, 1) 0%, rgba(0, 110, 239, 1) 100%);
}

body {
  border: 1px red solid;
}
._content {
  display: flex;
  flex-direction: column;
}
._content .inWrap {
  flex: 1;
}
._content .bottom-content {
  text-align: center;
  width: 100%;
  font-size: 14px;
  color: #bebebe;
  background: #fff;
  height: 30px;
}
._content .bottom-content span {
  color: #006eef;
}
</style>



// WEBPACK FOOTER //
// lib/pages/_login/index.vue